// @flow
import * as React from 'react';
import Coin from 'components/Coin';
import Glyph from 'components/Glyph';
import DeliveryStatus from 'constants/DeliveryStatus';

import './styles/DeliveryStatusIcon.scss';

const Icon = (props: *) => (
  <Coin
    size="small"
    className="DeliveryStatusIcon"
    border={props.coinBorderColor}
    color={props.coinBackgroundColor}>
    <Glyph
      solo
      name={props.glyphName}
      color={props.glyphColor}
      className="DeliveryStatusIcon-glyph"
    />
  </Coin>
);

type Props = {
  status: string,
};

class DeliveryStatusIcon extends React.Component<Props, void> {
  render() {
    switch (this.props.status) {
      case DeliveryStatus.DELIVERY_ERROR:
        return (
          <Icon
            glyphName="explanation"
            glyphColor="sunrise"
            coinBorderColor="sunrise"
            coinBackgroundColor="white"
          />
        );
      case DeliveryStatus.READ:
        return (
          <Icon
            glyphName="check"
            glyphColor="white"
            coinBorderColor="brand"
            coinBackgroundColor="brand"
          />
        );
      case DeliveryStatus.SENT:
        return (
          <Icon
            glyphName="check"
            glyphColor="shamrock"
            coinBorderColor="shamrock"
            coinBackgroundColor="white"
          />
        );
      case DeliveryStatus.DELIVERED:
        return (
          <Icon
            glyphName="check"
            glyphColor="white"
            coinBorderColor="shamrock"
            coinBackgroundColor="shamrock"
          />
        );
      default:
        return null;
    }
  }
}

export default DeliveryStatusIcon;
